import { render, staticRenderFns } from "./index.vue?vue&type=template&id=16063925&scoped=true&"
import script from "./index.vue?vue&type=script&scoped=true&lang=js&"
export * from "./index.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=16063925&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16063925",
  null
  
)

export default component.exports